import * as signalR from "@microsoft/signalr";

let connection = null;

export function getConnection(location) {
	if (!connection) {
		connection = new signalR.HubConnectionBuilder()
			.withUrl(location, {
				transport: signalR.HttpTransportType.WebSockets,
				withCredentials: true
			})
			.withAutomaticReconnect()
			.configureLogging(signalR.LogLevel.Information)
			.build();
	}

	return connection;
}